"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCartBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const primitives_richproducts_1 = require("@ariessolutionsio/primitives-richproducts");
const EmptyCartBanner = (props) => {
    const { data: { icon, markdown }, } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "mx-auto mb-9 mt-8 w-80 space-y-4 text-center", children: [icon?.file && ((0, jsx_runtime_1.jsx)("img", { src: icon?.file, alt: "cookie icon", className: "mx-auto w-[59px]" })), markdown && ((0, jsx_runtime_1.jsx)("div", { className: "font-semibold", children: (0, jsx_runtime_1.jsx)(primitives_richproducts_1.Markdown, { className: "prose", children: markdown }) }))] }));
};
exports.EmptyCartBanner = EmptyCartBanner;
